module.exports = __webpack_public_path__ + "static/img/山东分部背景@2x.3580729.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/山东分部背景@2x.png
// module id = +kEb
// module chunks = 0